import {
  Directive,
  ElementRef,
  Renderer2,
  AfterViewInit,
  HostListener,
  Input
} from '@angular/core'

@Directive({
  selector: '[autoscaleText]',
  standalone: true
})
export class AutoscaleTextDirective implements AfterViewInit {
  @Input() minFontSize = 10
  @Input() maxFontSize = 100

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this.fitText()
  }

  @HostListener('window:resize')
  onResize() {
    this.fitText()
  }

  private fitText() {
    const container = this.el.nativeElement.parentElement
    const textEl = this.el.nativeElement

    const containerWidth = container.clientWidth
    const containerHeight = container.clientHeight

    // Reset to max to test fit
    this.renderer.setStyle(textEl, 'font-size', `${this.maxFontSize}px`)

    let fontSize = this.maxFontSize

    // Shrink font until it fits
    while (fontSize > this.minFontSize) {
        const { scrollWidth, scrollHeight } = textEl

        const maxWidth = containerWidth * 1
        const maxHeight = containerHeight * 1

        if (scrollWidth <= maxWidth && scrollHeight <= maxHeight) {
            break
        }

        fontSize -= 2;
        this.renderer.setStyle(textEl, 'font-size', `${fontSize}px`)
    }

    // Center text
    this.renderer.setStyle(textEl, 'display', 'block')
    this.renderer.setStyle(textEl, 'width', '100%')
    this.renderer.setStyle(textEl, 'text-align', 'center')
  }
}
